<template>
  <div class="content-text">
    <h2 class="title-2 text-left">2 Componente equidade</h2>
    <p>
      Este componente foi projetado considerando a vulnerabilidade social do
      município, assim como o seu tamanho populacional. O gestor pode sempre
      contar com ele, pois não varia. Ele também ajuda o gestor na implantação
      de novas equipes.
    </p>
    <h2 class="title-3 text-left">2.1 Implantação</h2>
    <!-- <p v-html="fixo.implantacao"></p> -->
    <p>
      Recurso de implantação em parcela única que o gestor municipal de saúde
      pode utilizar para estruturar e implantar novas equipes de eSF, eAP, eSB,
      eMulti, eSFR, eCR ou eAPP.
    </p>
    <h2 class="title-3 text-left">2.2 Custeio</h2>
    <p>
      Como a classificação é {{ dados.etapa3.ied.value }} no IED,
      <b
        >{{ dados.etapa1.cidade.no_municipio }} –
        {{ dados.etapa1.estado.uf }}</b
      >
      tem seu custeio mensal fixo definido conforme apresentado no Quadro 1, que
      mostra a quantidade de equipes, o valor por equipe e o valor total mensal
      por tipo de equipe.
    </p>

    <div class="container-table">
      <span style="text-transform: uppercase; font-weight: bold"
        >Quadro 1 – Valor fixo de custeio por equipe no componente equidade
      </span>
      <table>
        <thead>
          <tr>
            <th>QUANTIDADE</th>
            <th>VALOR POR EQUIPE</th>
            <th>TOTAL MENSAL</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in equipesFiltradas" :key="index">
            <td class="text-center">{{ item.quantidade }} {{ item.label }}</td>
            <td class="text-center">R$ {{ item.valorPorEquipe }}</td>
            <td class="text-center">R$ {{ item.valorTotalPorEquipe }}</td>
          </tr>
          <tr class="grey">
            <td colspan="2"><strong>Total geral</strong></td>
            <td class="text-center">
              <strong>R$ {{ totalGeral }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
      <span class="fonte" v-html="fonte"></span>
    </div>

    <p>
      Esse valor é depositado mensalmente e pode ser consultado de forma
      detalhada no
      <a
        href="https://consultafns.saude.gov.br/#/detalhada"
        target="_blank"
        style="text-decoration: none"
        >site</a
      >
      do Fundo Nacional de Saúde (FNS).
    </p>
  </div>
</template>

<script>
export default {
  props: {
    dados: {
      type: Object,
      default: () => {},
    },
    fixo: {
      type: Object,
      default: () => {},
    },
    regras: {
      type: Object,
      default: () => {},
    },
    fonte: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      equipes: [],
      totalGeral: 0,
    }
  },
  mounted() {
    this.formatarEquipes()
  },
  computed: {
    equipesFiltradas() {
      return this.equipes.filter((item) => {
        return Number(item.quantidade || 0) > 0
      })
    },
  },
  methods: {
    /**
     * Retorna a quantidade da equipe conforme o label usado nas regras.
     *
     * @param {String} label
     * @returns {Number}
     */
    getQuantidadeEquipe(label) {
      const equipesImplantadas = this.dados?.etapa4?.totaisEquipes || {}

      const aliases = {
        'eSF 40h': 'eSF',
      }

      const labelEtapa4 = aliases[label] || label

      return Number(equipesImplantadas[labelEtapa4] || 0)
    },

    /**
     * Formata as equipes do componente fixo de custeio.
     *
     * @returns {void}
     */
    formatarEquipes() {
      const ied = this.dados?.etapa3?.ied?.value

      const valoresDasEquipesCusteio = this.regras.custeio.find((item) => {
        return item.ied === ied
      })

      if (!valoresDasEquipesCusteio) {
        return
      }

      this.equipes = []
      this.totalGeral = 0

      valoresDasEquipesCusteio.tipos_equipes.forEach((element) => {
        const quantidadeDeEquipes = this.getQuantidadeEquipe(element.label)
        const totalPorEquipe = element.valor * quantidadeDeEquipes

        this.equipes.push({
          label: element.label,
          quantidade: quantidadeDeEquipes,
          valorPorEquipe: element.valor.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
          }),
          valorTotalPorEquipe: totalPorEquipe.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
          }),
        })

        this.totalGeral += totalPorEquipe
      })

      this.totalGeral = this.totalGeral.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      })
    },
  },
}
</script>

<style lang="scss"></style>
